var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsDecorativeTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 370,
    viewBox: "0 0 361 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    clipPath: "url(#clip0_4946_8827)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.152,
    height: 37.152,
    rx: 18.576,
    transform: "matrix(0.735676 -0.677334 -0.677334 -0.735676 85.8984 269.829)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 294.894,
    height: 37.152,
    rx: 18.576,
    transform: "matrix(0.735676 -0.677334 -0.677334 -0.735676 90.3828 369.866)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.152,
    height: 37.152,
    rx: 18.576,
    transform: "matrix(0.735676 -0.677334 -0.677334 -0.735676 279.996 195.287)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 248.041,
    height: 37.152,
    rx: 18.576,
    transform: "matrix(0.735676 -0.677334 -0.677334 -0.735676 225.883 358.733)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 304.182,
    height: 37.152,
    rx: 18.576,
    transform: "matrix(0.735676 -0.677334 -0.677334 -0.735676 146.285 213.309)",
    fill: "#435E64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4946_8827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 370,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsDecorativeTopRight);
export default __webpack_public_path__ + "static/media/documents-decorative-top-right.5c92efc5e2ed3c4552a107218eed4752.svg";
export { ForwardRef as ReactComponent };